import apiAsync from 'infrastructure/shared/api/api-async'
import { FetchTokenResponse } from '../types'

export const fetchToken = (
  tokenUuid: string | undefined,
  showLoading = true
): Promise<FetchTokenResponse> => {
  return apiAsync.requestSync({
    endpoint: 'msPlatform',
    path: `tokens/${tokenUuid}`,
    method: 'GET',
    showLoading: showLoading
  })
}
